import { savePhasesToStorage } from "@Helpers/phase-storage";
import { usePractise, UsePractiseResponse } from "@hooks/game/use-practise";
import React, { createContext, ReactNode, useContext, useState } from "react";

interface PractiseContextType extends UsePractiseResponse {
  // Only UI dialog state
  isPositionDialogOpen: boolean;
  openPositionDialog: () => void;
  closePositionDialog: () => void;
  handlePositionsSelected: (positions: any[]) => void;
  isPhasesDialogOpen: boolean;
  openPhasesDialog: () => void;
  closePhasesDialog: () => void;
  handlePhasesSelected: (phases: any[]) => void;
}

const PractiseContext = createContext<PractiseContextType | undefined>(undefined);

export const PractiseProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isPositionDialogOpen, setIsPositionDialogOpen] = useState(false);
  const [isPhasesDialogOpen, setIsPhasesDialogOpen] = useState(false);

  const practiseData = usePractise();

  const openPositionDialog = () => setIsPositionDialogOpen(true);
  const closePositionDialog = () => {
    setIsPositionDialogOpen(false);
  };
  const handlePositionsSelected = (positions: any[]) => {
    practiseData.setSelectedPositions(positions);
    setIsPositionDialogOpen(false);
  };

  const openPhasesDialog = () => setIsPhasesDialogOpen(true);
  const closePhasesDialog = () => {
    setIsPhasesDialogOpen(false);
  };
  const handlePhasesSelected = (phases: any[]) => {
    practiseData.setSelectedPhases(phases);
    savePhasesToStorage(phases);
    setIsPhasesDialogOpen(false);
  };

  const contextValue = {
    ...practiseData,
    isPositionDialogOpen,
    openPositionDialog,
    closePositionDialog,
    handlePositionsSelected,
    isPhasesDialogOpen,
    openPhasesDialog,
    closePhasesDialog,
    handlePhasesSelected,
  };

  return <PractiseContext.Provider value={contextValue}>{children}</PractiseContext.Provider>;
};

export const usePractiseContext = () => {
  const context = useContext(PractiseContext);
  if (context === undefined) {
    throw new Error("usePractiseContext must be used within a PractiseProvider");
  }
  return context;
};
